<div class="dialog-container2 grid-y align-middle {{ containerClass }}">
  <button
    aria-label="Close"
    type="button"
    *ngIf="isCloseIconVisible"
    class="close-btn"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon class="close-icon" svgIcon="close-blue"></mat-icon>
  </button>

  <section class="dialog-container2__header grid-y align-middle">
    <img
      alt=""
      *ngIf="icon"
      class="dialog-icon"
      src="assets/images/dialog/{{ icon }}.svg"
    />
    <!-- Rendered only when there is a title. A dialog that projects its own
         heading into [dialog-header] otherwise inherits 32px of empty flex row
         above it. -->
    <div class="cell" *ngIf="title">
      <div class="text-center font-semibold text-2xl">{{ title }}</div>
    </div>
    <ng-content select="[dialog-header]"></ng-content>
  </section>
  <section class="dialog-container2__body">
    <div *ngIf="message" class="message">
      {{ message }}
    </div>
    <ng-content select="[dialog-body]"></ng-content>
  </section>
</div>
